<!-- Collect Dues Sidebar -->
<p-drawer [(visible)]="showPaymentSummary" [showCloseIcon]="false" [blockScroll]="true" [dismissible]="false"
  [closeOnEscape]="false" position="right" styleClass="w-full payment-sidebar" appendTo="body" [modal]="true"
  (onHide)="closeBillingSideBar()">

  <ng-template #headless>
  <!-- Header -->
  <div class="-mt-3 p-3 border-bottom-1 border-300 relative flex align-items-center justify-content-between">

    <h4 class="flex align-items-center mb-0 mr-3 font-normal">
      <i class="fa fa-cart-shopping text-500 mr-3"></i>
      <span class="text-base">{{'PAYMENT.COLLECT_DUES' | translate}}</span>
    </h4>

    <!-- Close Icon -->
    <i class="fa fa-times text-xl text-600 cursor-pointer absolute right-0 top-0 mt-3 mr-3"
      (click)="closeBillingSideBar()">
    </i>
    <!-- Close Icon -->

  </div>
  <!-- Header -->

  <!-- Content Wrapper -->
  <div class="p-sidebar-content__wrapper">

    <!-- Name -->
    <div class="flex px-3 py-2 align-items-center justify-content-between border-bottom-1 border-300"
      *ngIf="client$ | async as client;">
      <div class="flex align-items-center">
        <div class="h-2rem w-2rem">
          <p-avatar *ngIf="client.image; else noContactPic" [image]="client.image" size="small" shape="circle"></p-avatar>
          <ng-template #noContactPic>
            <p-avatar [label]="client.full_name | titlecase | shortName" shape="circle"></p-avatar>
          </ng-template>
        </div>
        <h3 class="mb-0 ml-2 md:-mt-1">
          <a href="../client/profile/{{ client.id }}"
            class="text-primary text-base mr-2 font-bold border-bottom-1 border-white hover:border-primary">
            {{ client.full_name }}
          </a>
          <span class="text-600 font-normal text-sm">
            {{'common.DATA.CLIENT_ID' | translate}} - {{client.id}}
          </span>
        </h3>
      </div>
      <div [innerHTML]="clientStatus(client)"></div>
    </div>
    <!-- Name -->


    <!-- Pending Due -->
    <div class="p-3 border-bottom-1 border-300">

      <p-table [value]="inv" styleClass="p-0 border-1 border-300 border-round mb-2" responsiveLayout="scroll">
        <ng-template pTemplate="header">
          <tr>
            <th class="surface-100 border-y-none">
              <span class="text-xs text-600 white-space-nowrap">
                {{'PAYMENT.DATE' | translate}}
              </span>
            </th>
            <th class="surface-100 border-y-none">
              <span class="text-xs text-600 white-space-nowrap">
                {{'PAYMENT.INVOICE' | translate}}
              </span>
            </th>
            <th class="surface-100 border-y-none"><span class="text-xs text-600 white-space-nowrap">
                {{'PAYMENT.AMOUNT' | translate}}</span>
            </th>
            <th class="surface-100 border-y-none"><span class="text-xs text-600 white-space-nowrap">
                {{'PAYMENT.BALANCE' | translate}}</span>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-inv>
          <tr class="text-sm hover:surface-100 h-full">
            <td cclass="y-2 white-space-nowrap">
              <form [formGroup]="paymentDateForm">
                <p-datepicker 
                [minDate]="disableDatesUpTo" 
                [placeholder]="'SCHEDULE.VIEWCLASS.SELECTDATE' | translate"
                styleClass="w-full"
                inputId="buttondisplay"
                appendTo="body"
                formControlName="paymentDate" />
              </form>
            </td>
            <td class="py-3 white-space-nowrap">{{inv.number_prefix }}
            </td>
            <td class="py-3 white-space-nowrap align-items-center">
              {{inv.total_amount_in_minor_currency |currencyformat }}
            </td>
            <td class="py-3 white-space-nowrap">
              <strong>{{inv.total_balance_due_in_minor_currency |currencyformat }}</strong>
            </td>
          </tr>
        </ng-template>
      </p-table>
      <div class="p-3 surface-900 text-white flex align-items-center justify-content-between border-round-bottom">
        <div>{{'PAYMENT.TOTAL_DUES' | translate}}</div>
        <div class="text-right ml-2">
          <strong class="block">{{this.totalBalance$ | async | currencyformat }}</strong>
          <small class="block text-xxs text-600">{{'PAYMENT.PRICE_INCLUSIVE' | translate }}</small>
        </div>
      </div>

        <!-- Sales Rep -->
        <div class="py-3">
          <label class="font-medium text-700 text-xs mb-2 block uppercase">{{'POS.MEMBERSHIP_ADDON.BILL_OWNER' | translate}}</label>

          <staff-selector [formGroup]="PaymentSummaryForm" [controlName]="billingOwner" [id]='_selectedstaff'
          [styleClass]="'w-full text-sm py-0 align-items-center'" [placeHolder]="'CreateEditStaff.SELECT_PLACEHOLDER' | translate"
          [filterstaff]="_filterStaff">
        </staff-selector>
        <app-error-msg *ngIf="billingOwner.dirty && billingOwner.invalid" [errors]="billingOwner.errors"
          [fieldLabel]="'POS.MEMBERSHIP_ADDON.BILL_OWNER' | translate">
        </app-error-msg>
        </div>
        <!-- Sales Rep -->

    </div>
    <!-- Pending Due -->
  </div>
  <!-- Content Wrapper -->

  <!-- Bottom Part -->
  <div class="sticky bottom-0 right-0 w-full text-center p-3 surface-400 shadow-3 z-5">
    <div class="relative mx-auto">
      <p-button styleClass="w-full justify-content-center align-items-center p-0" (click)="showPaymentModule()">
        <div class="flex align-items-center mr-3 p-3 w-full">
          <strong class="p-button-label ml-2">{{'PAYMENT.OFFLINE_CONTINUE' | translate}}</strong>
        </div>
      </p-button>
    </div>
  </div>
  <!-- Bottom Part -->
  </ng-template>
</p-drawer>
<!-- Collect Dues Sidebar -->

<other-payment *ngIf="otherPaymentsModal$ | async" [otherPaymentsModal]="otherPaymentsModal$ | async" [creditBalance]="clientCreditBalance"
  [showCreditBalance]="showCreditBalance" [totalAmtTobePaid]="totalBalance$ | async" (hideOtherPaymentDialog)="HideOtherPaymentDialog($event)">
</other-payment>

<app-errors *ngIf="showErrorPopup | async as showPopup" [error]="error" [visible]="showPopup"
  [errorData]="errorMessages" (hideErrorPopup)="HideErrorPopup($event)">
</app-errors>
